import { Controller } from "stimulus";

export default class extends Controller {
   connect() {
     // Dev Notes: Documentation for $.selectpicker() plugin -
     // https://www.npmjs.com/package/bootstrap-select
     // https://developer.snapappointments.com/bootstrap-select/
     this.element.querySelectorAll('select').forEach(x => $(x).selectpicker());
   }
}